import { ACTIONS } from "../../Models/ENUM";
import CONQUER from "../CONQUER";
import AvatarInstance from "./AvatarInstance";
import LOG, { log } from "../../UTIL/LOG";
import Cue from "../../UTIL/Instances/Cue";
import AVATAR from "../../Core/USER/AVATAR/AVATAR";
import ARRAY from "../../UTIL/ARRAY";

class Bots 
{
  private conquer   : CONQUER;
  private cue       : Cue = new Cue( true );
  public data       : any = {};
  private isLoaded  : boolean = false;
 
  public constructor( conquer: CONQUER ) 
  {
    this.conquer  = conquer;
  }

  public init()
  {
 
  }

  /*=============== 


  GET

  Gets 200 bots


  ================*/

  public async get( amount ?: number ) : Promise<any> 
  {
 
    if( this.isLoaded ) return Promise.resolve( this.doGet( amount ) );

    this.cue.clear();
 
    let array       = await this.conquer.do( ACTIONS.BOT_GET );
    let bots : any  = [];
 
    for ( var n in array ) bots.push( this.conquer.Avatars.pushInstance( array[n] ) );

    this.cue.copy( bots );
 
    this.isLoaded   = true;

    return Promise.resolve( this.doGet( amount ) );
  }

  private doGet( amount ?: number )
  {
    if( !amount ) return this.cue._pool;

    let output : any = [];

    while( output.length<amount ) ARRAY.pushUnique( output, this.cue.get() );

    return output;
  }

  /*=============== 


  SET
 

  ================*/
  /*
  public async set( avatarID:string, data:any ) : Promise<any>
  {
      var value   = await this.conquer.do( ACTIONS.BOT_SET, { avatarID:avatarID, data:data } );

      return Promise.resolve( value );
  }*/
 
}

export default Bots;
